import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4etrhoste6: FaireBrandEntity = {
  token: "b_4etrhoste6",
  type: "brand",
  name: "SKYLAR ROSE",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9e83a2268c36a24d4e89b4203f3f58940d6e59db4a71a0f703aa354dcb6b58f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9ce5568fbdcbd85e36674b6472a065f266e3d61047a4ae0036a8a0475c892c08.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c9e83a2268c36a24d4e89b4203f3f58940d6e59db4a71a0f703aa354dcb6b58f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9ce5568fbdcbd85e36674b6472a065f266e3d61047a4ae0036a8a0475c892c08.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "At Skylar Rose, we celebrate the vibrant spirit of the modern woman. Our contemporary clothing line, established in 2008, is designed for youthful, cheerful, and active individuals.  We believe fashion should be an expression of joy and a way to enhance everyday life.\n\nWe create pieces that effortlessly blend style and comfort, allowing you to move freely while looking fabulous, whether you’re running errands, enjoying brunch with friends, or attending a day event. Our collections are infused with playful colors, trendy patterns, and versatile styles, empowering you to mix and match for any occasion.\n\nJoin us on this journey of fun and self-expression, where every outfit is a chance to celebrate your unique style. Elevate your wardrobe with Skylar Rose, and let’s make life a little more beautiful together!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:25.151Z",
    importedBy: "entity-db-cli",
  },
};
